import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Custom hook to scroll to top when location changes
 * This ensures that when switching between tabs or navigating to different routes,
 * the page always starts from the top
 */
export const useScrollToTop = () => {
  const location = useLocation();

  useEffect(() => {
    // Scroll to top whenever the location changes
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth' // Use smooth scrolling for better UX
    });
  }, [location.pathname, location.search, location.hash]);
};

/**
 * Utility function to scroll to top immediately
 * Useful for tab switching or manual scroll-to-top actions
 */
export const scrollToTop = () => {
  window.scrollTo({
    top: 0,
    left: 0,
    behavior: 'smooth'
  });
};

/**
 * Utility function to scroll to top instantly (without animation)
 * Useful when you need immediate scroll without smooth behavior
 */
export const scrollToTopInstant = () => {
  window.scrollTo(0, 0);
};
